export default __webpack_public_path__ + "static/media/1.68cd1153.webp";